import Heading from 'e-submission/components/Heading'

export default (hoc) => hoc(Heading)
